import React from 'react'
import Title from './Title'
import {FaCertificate} from "react-icons/fa"
import { graphql, useStaticQuery } from "gatsby"

export default function Certificates() {

    const data = useStaticQuery(query)
    const { allStrapiCertificates : { nodes : certificates },} = data

    return <section className="section bg-grey">
    <Title title="Certificates" />
    <div className="section-center">
      {
          certificates.map((cer)=>{
            return  <a href={cer.url} target="blank" key={cer.id}>
            <div className="job-desc">
            <FaCertificate className="job-icon"></FaCertificate>
            <p>
                <span className="cer-title">{cer.title}</span> - <span className="cer-platform">{cer.platform}</span>
            </p>
          </div>
            </a>
          })
      }
    </div>
  </section>
}


export const query = graphql`
  {
    allStrapiCertificates(sort: {fields: date, order: DESC}) {
      nodes {
        id
        title
        platform
        date
        url
      }
    }
  }
`